export * from "./atoms";
export * from "./organisms";
import { CarouselAtoms } from "./atoms";
import { CarouselOrganisms } from "./organisms";

export const CarouselComponents = [...CarouselOrganisms, ...CarouselAtoms];
